import { ComponentGroupInfo } from '../page-object'

const data: Array<ComponentGroupInfo> = []

export default data
